export const DASHBOARD_API = process.env.REACT_APP_DASHBOARD_API || '';
export const DASHBOARD_IMAGES = process.env.REACT_APP_BUCKET_URL || '';
export const RECTORAL_BOARD_SITE = process.env.REACT_APP_RECTORAL_BOARD_URL || '';
export const GOOGLE_MAP_API_KEY = process.env.REACT_APP_GOOGLE_MAP_API_KEY || '';
